import {
  handleActions,
  combineActions,
} from 'redux-actions';
import update from 'immutability-helper';
import InvitationActionCreators from '../actions/InvitationActionCreators';

const {
  getInvitationListRequest,
  getInvitationListSuccess,
  getInvitationListFailure,
  getAssignableRolesRequest,
  getAssignableRolesSuccess,
  getAssignableRolesFailure,
  sendInvitationRequest,
  sendInvitationSuccess,
  sendInvitationFailure,
  resendInvitationRequest,
  resendInvitationSuccess,
  resendInvitationFailure,
} = InvitationActionCreators;

const initialState = {
  isLoading: false,
  roles: [],
  invitations: [],
};

export default handleActions({
  [combineActions(
    getInvitationListRequest,
    getAssignableRolesRequest,
    sendInvitationRequest,
    resendInvitationRequest,
  )]: state => update(state, {
    isLoading: { $set: true },
  }),
  [getInvitationListSuccess]: (state, { payload }) => update(state, {
    isLoading: { $set: false },
    invitations: { $set: payload },
  }),
  [getAssignableRolesSuccess]: (state, { payload }) => update(state, {
    isLoading: { $set: false },
    roles: { $set: payload },
  }),
  [combineActions(
    getInvitationListFailure,
    getAssignableRolesFailure,
    sendInvitationSuccess,
    sendInvitationFailure,
    resendInvitationSuccess,
    resendInvitationFailure,
  )]: state => update(state, {
    isLoading: { $set: false },
  }),
}, initialState);



// WEBPACK FOOTER //
// ./src/reducers/invitation.js